module.exports = __webpack_public_path__ + "static/Overcast-Podcasts-485dd5673aceba8ed5efc5e4ddbc0d86.png";